export default {
  initFromStorage (state, opt) {
    for (const i in opt) {
      state[i] = opt[i]
    }
  },
  setSessionToken (state, sessionToken) {
    state.sessionToken = sessionToken
  },
  setUser (state, user) {
    state.user = user
  },
  // 判断是否已同意隐私协议
  setIsRead (state, isRead) {
    state.isRead = isRead
  },
  // 保存广告图片地址
  setAdMapImage (state, adMapImage) {
    state.adMapImage = adMapImage
  },
  // 保存购物车计数
  setShoppingSum (state, shoppingSum) {
    state.shoppingSum = shoppingSum
  },
  // 搜索数组
  setSearchWords (state, searchWords) {
    state.searchWords = searchWords
  },
  // 收货地址id
  setAddressId (state, addressId) {
    state.addressId = addressId
  },
  // 要结算的数据
  setSelectedData (state, selectedProductsData) {
    state.selectedProductsData = selectedProductsData
  },
  // order列表中间值
  setOrderMiddleValue (state, orderMiddleValue) {
    state.orderMiddleValue = orderMiddleValue
  },
  // 底部导航栏状态
  setFooterStatus (state, toggleFooter) {
    state.toggleFooter = toggleFooter
  }
}
